import axios from 'axios';
import Vue from 'vue';

export function parseVideoUrl(originalUrl) {
    let url = originalUrl.trim();

    if (url.indexOf('http') !== 0) {
        url = 'http://' + url;
    }

    let source;
    let id;

    if (url.indexOf('youtube.com/') !== -1) {
        source = 'youtube';
        id = url.match(/[&?]v=([^&?]+)/)[1]; // `v` query param
    } else if (url.indexOf('youtu.be/') !== -1) {
        source = 'youtube';
        id = url.split('?')[0].split('/')[3]; // First path segment
    } else if (url.indexOf('vimeo.com/') !== -1) {
        source = 'vimeo';
        id = url.split('?')[0].split('/').slice(-1).filter(Boolean)[0]; // Last path segment
    } else if (url.indexOf('facebook.com/') !== -1) {
        source = 'facebook';
        id = url;
    } else {
        throw new Error(`Failed to parse video URL: ${originalUrl}`);
    }

    return { source, id };
}

export async function getEmbeddedVideoMarkup(source, id) {
    try {
        const response = await axios.post('/apiv2/social/video', {
            'video_source': source,
            'video_id': id,
        });
        return response.data.data.video;
    } catch (error) {
        console.error(error);
        throw new Error(`Couldn’t get embed video ${id} (${source})`);
    }
}

export async function processNewEmbeddedVideos() {
    await Vue.nextTick(); // Wait for any DOM changes.

    return new Promise((resolve, reject) => {
        try {
            const FB = window.FB;

            if (FB) {
                FB.XFBML.parse();
            } else {
                console.warn('`FB` is probably still loading. It’ll parse on its own on init.');
            }

            resolve();
        } catch (error) {
            reject(error);
        }
    });
}
